function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFinance = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.149,
    y: 1.689,
    width: 44,
    height: 44,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.649,9.189L23.649,9.845C24.049,9.92 24.437,10.014 24.787,10.108C25.587,10.32 26.062,11.145 25.849,11.945C25.637,12.745 24.812,13.22 24.012,13.008C23.33,12.826 22.693,12.701 22.124,12.695C21.668,12.689 21.205,12.801 20.912,12.97C20.78,13.051 20.718,13.12 20.693,13.158C20.674,13.189 20.649,13.233 20.649,13.333L20.649,13.37C20.662,13.383 20.705,13.445 20.855,13.533C21.218,13.751 21.755,13.92 22.568,14.164L22.624,14.183C23.318,14.389 24.243,14.67 24.993,15.139C25.849,15.676 26.624,16.57 26.643,17.945C26.662,19.351 25.93,20.376 24.974,20.976C24.555,21.233 24.105,21.414 23.643,21.527L23.643,22.189C23.643,23.02 22.974,23.689 22.143,23.689C21.312,23.689 20.643,23.02 20.643,22.189L20.643,21.477C20.049,21.333 19.505,21.145 19.043,20.989C18.912,20.945 18.787,20.901 18.668,20.864C17.88,20.601 17.455,19.751 17.718,18.964C17.98,18.176 18.83,17.751 19.618,18.014C19.78,18.07 19.93,18.12 20.074,18.17C20.924,18.458 21.537,18.664 22.193,18.689C22.693,18.708 23.137,18.589 23.393,18.433C23.512,18.358 23.568,18.295 23.593,18.251C23.618,18.214 23.649,18.139 23.643,17.995L23.643,17.983C23.643,17.92 23.643,17.851 23.393,17.695C23.037,17.47 22.499,17.295 21.699,17.051L21.58,17.014C20.905,16.814 20.018,16.545 19.305,16.114C18.462,15.608 17.649,14.739 17.643,13.358C17.636,11.926 18.449,10.945 19.374,10.395C19.774,10.158 20.205,9.995 20.637,9.883L20.637,9.189C20.637,8.358 21.305,7.689 22.137,7.689C22.968,7.689 23.637,8.358 23.637,9.189L23.649,9.189ZM39.662,28.708C40.48,29.82 40.243,31.383 39.13,32.202L31.218,38.033C29.755,39.108 27.993,39.689 26.174,39.689L6.149,39.689C5.043,39.689 4.149,38.795 4.149,37.689L4.149,33.689C4.149,32.583 5.043,31.689 6.149,31.689L8.449,31.689L11.255,29.439C12.674,28.302 14.436,27.689 16.255,27.689L26.149,27.689C27.255,27.689 28.149,28.583 28.149,29.689C28.149,30.795 27.255,31.689 26.149,31.689L21.149,31.689C20.599,31.689 20.149,32.139 20.149,32.689C20.149,33.239 20.599,33.689 21.149,33.689L28.687,33.689L36.168,28.177C37.28,27.358 38.843,27.595 39.662,28.708ZM16.249,31.689L16.193,31.689L16.249,31.689Z",
    style: {
      fill: "#00659d",
      fillRule: "nonzero"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFinance);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/finance.3e9099a1a2d5f8e5d51f2b42ea83fafa.svg";